import { msaGatePending } from './msa.js';

/** The steps of signing a master services agreement, after the documents. */
export const MSA_DETAILS_STEP = 'msa-details';
export const MSA_SIGN_STEP = 'msa-sign';

/**
 * The steps a freelancer goes through before the app opens, in order.
 *
 * Onboarding (their master services agreement is still unsigned) is every
 * platform document, then entering their legal name and address and signing
 * the agreement. Documents already accepted stay in the list, so a reload
 * still shows them as done.
 *
 * A freelancer whose agreement is in force is only ever re-accepting updated
 * documents, so the steps are just those: listing the rest would show
 * documents they accepted long ago as still to come.
 *
 * The app builds this once, when the gates open, so the count doesn't shrink
 * as steps are done.
 *
 * @param {Array<{ key: string, title: string, accepted: boolean }>} agreements
 * @param {string | null | undefined} msaStatus
 * @returns {Array<{ key: string, label: string }>}
 */
export function onboardingSteps(agreements, msaStatus) {
    const onboarding = msaGatePending(msaStatus);
    const steps = agreements
        .filter((a) => onboarding || !a.accepted)
        .map((a) => ({ key: a.key, label: a.title }));
    if (onboarding) {
        steps.push(
            { key: MSA_DETAILS_STEP, label: 'Legal Name and Address' },
            { key: MSA_SIGN_STEP, label: 'Master Services Agreement' },
        );
    }
    return steps;
}

/**
 * The step indicator's position for a step, or -1 when the step isn't in the
 * list.
 * @param {Array<{ key: string }>} steps
 * @param {string} key
 * @returns {number}
 */
export function stepIndex(steps, key) {
    return steps.findIndex((s) => s.key === key);
}
